/**
 * extract display label from full document_type string, found in KABOODLE_SORT_ORDER var in backend
 * examples:
 *   "Medical Records (include...)" → "Medical Records"
 *   "Query - (Found / Not found)" → "Query"
 *   "Junk" → "Junk"
 */
export const getDocumentTypeLabel = (documentType: string): string => {
  return documentType
    .split("(")[0]
    .replace(/[-\s]+$/, "")
    .trim();
};
